import { render, staticRenderFns } from "./sendEmail.vue?vue&type=template&id=3b64d156"
import script from "./sendEmail.vue?vue&type=script&lang=js"
export * from "./sendEmail.vue?vue&type=script&lang=js"
import style0 from "./sendEmail.vue?vue&type=style&index=0&id=3b64d156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports